/* eslint-disable react/prop-types */
import React from 'react';
import Modal from './Modal/index';
import './vendorordermodal.css'; 
import { Button } from 'react-bootstrap';

const VendorOrderModal = ({ vendorModalShow, handleCloseVendorModal }) => {
  return (
    <Modal
      show={vendorModalShow}
      onHide={handleCloseVendorModal}
      className="vendor_order_modal"
      title="Order Appraisal"
      size="md"
    >
      <div className="vendor_order_content">
        <a 
          href={process.env.REACT_APP_CDN_LINK + "downloads/User_Guide_Ordering_Appraisal_through_SWMC_website.pdf"} 
          target="_blank" 
          rel="noopener noreferrer"
          className="vendor_order_link"
        >
          Click here to download the user guide for ordering appraisal
        </a>

        <Button
          className="vendor_order_button" 
          href="https://revmort7.reversesoftonline.com/ReverseMortgage/jsp/extVendorLogin.jsf" 
          target="_blank"
        >
          Continue
        </Button>
      </div>
    </Modal>
  );
};

export default VendorOrderModal;